import { useMemo } from "react";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store";
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { InputPrefix } from "./InputPrefix"

interface CiclosBateriasInputProps {
  errorState: string[];
  formState: FormProjetoHibridoType;
  onChangeValue: (formState: Partial<FormProjetoHibridoType>) => void;
}

export const HIBRIDO_SEM_BATERIA_OPTION = { id: 0, nome: "Sem bateria" }

export const TipoBateriaInput = ({ errorState, formState, onChangeValue }: CiclosBateriasInputProps) => {
  const projetosHibridoStoreStateValidations = useProjetosHibridoStore (store => store.state.validations)
  const projetosHibridoStoreState = useProjetosHibridoStore (store => store.state.data)
  const projetosHibridoStoreActions = useProjetosHibridoStore (store => store.actions)

  const options = useMemo(()=>{
    const baterias = projetosHibridoStoreState.baterias.map(item => ({ id: item.id, nome: item.nome }))
    return [HIBRIDO_SEM_BATERIA_OPTION, ...baterias]
  },[projetosHibridoStoreState.baterias])

  return (
    <InputComboBoxList
      id={"hibrido-tipo-bateria-field"}
      key={`hibrido-tipo-bateria-field`}
      label={"* Tipo de Bateria"}
      textField="nome"
      prefix={<InputPrefix />}
      valueField="id"
      error={!!projetosHibridoStoreStateValidations.tipo_bateria.helper || errorState.includes('tipo_bateria')}
      helperText={projetosHibridoStoreStateValidations.tipo_bateria.helper}
      options={options}
      value={formState?.tipo_bateria || null}
      renderOptions={(option: any) => {
        return `${option?.nome}`
      }}
      renderOptionsLabel={(option: any) => {
          return `${option?.nome}`
      }}
      disabled={!projetosHibridoStoreState.estado}
      disableClearable
      onChange={(value) => {
        const payload: Partial<typeof formState> = { tipo_bateria: value, recalcular: true };
        const cargasPrioritarias = formState.cargas_prioritarias.filter(item => !item["@remove"]);
        const limparCampos = !!cargasPrioritarias.length || !!formState.taxa_descarga?.id

        if (payload.tipo_bateria !== undefined && payload.tipo_bateria?.id === 0 && limparCampos) {
          confirmationDialog.setup({
            content: `Ao selecionar “Sem bateria”, os campos de “Taxa de descarga” e “Carga dos Equipamentos” serão desconsiderados. Deseja continuar?`,
            title: "Aviso!",
            onClose: () => {
              confirmationDialog.close();
            },
            onConfirmation: () => {
              projetosHibridoStoreActions.resetCargasPrioritarias();
              projetosHibridoStoreActions.changeValue({ ...payload, taxa_descarga: null})
              confirmationDialog.close();
            },
          });
          
          confirmationDialog.open()
        } else {
          projetosHibridoStoreActions.changeValue(payload)
        }
      }}
    />
  )
}